module.exports = "//static.hsappstatic.net/LoginUI/static-1.14998/img/login-marketing-image.png"